export default __webpack_public_path__ + "static/our-vision-00494bfcefb6db3439aa0975b576cc89.png";